import {
  ISimpleObjectWithCode,
  ISimpleObjectWithCodeNew,
} from "@inceptionbg/ui-components";
import { IHolderNew } from "./IHolder";
import { IApproval, INameCode } from "./IBase";
import { IContactInfo, IContactInfoNew } from "./IContactInfo";
import { IMemberNew } from "./IMember";
import { IEvidence } from "./IFile";
import { ILand } from "./ILand";
import { ConsentType } from "./IConsent";

// export type IOrganizationalForm = "COMMERCIAL" | "NON_COMMERCIAL";
export type IRegistrationStatus = "PENDING" | "WAITING_COMPLEMENT";

export interface IFarmBasic {
  uuid: string;
  name: string;
  status: string;
  registrationNumber: string;
}

export interface IBusinessActivity {
  uuid: string;
  code: string;
  name: string;
  type: "AGRICULTURAL_PROCESSING" | "OTHER";
}

export interface IFarm {
  uuid: string;
  registrationNumber: string;
  status: IFarmStatus;
  passiveStatusReason: IPassiveStatusReason;
  renewalDate: string;
  activeStatusDays: number;
  registrationDate: string;
  latestChangeDate: string;
  organizationForm: ISimpleObjectWithCode;
  membersCount?: number;
  activeMembersCount?: number;
  holder: IHolderNew;
  headOffice: IHeadOfficeNew;
  contactInfo: IContactInfo;
  bankAccount?: IBankAccount;
  legalRepresentative?: ILegalRepresentativeNew;
  communicationChannel?: ICommunicationChannel;
  sendToHermes?: boolean;
  agriculturalProduction?: boolean;
  agriculturalProductsProcessing?: boolean;
  nonAgriculturalProduction?: boolean;
  agriculturalBusinessActivities?: IBusinessActivity[];
  otherAgriculturalBusinessActivities?: IBusinessActivity[];
  registrationStatus?: IRegistrationStatus;
  registrationApproval?: IApproval;
  lands?: ILand[];
  totalSurface?: number;
  totalGrantSurface?: number;
  dataConsentType?: ConsentType;
}

export interface IFarmNew {
  uuid?: string;
  registrationNumber?: string;
  status?: IFarmStatus;
  organizationForm?: ISimpleObjectWithCodeNew;
  holder?: IHolderNew;
  headOffice?: IHeadOfficeNew;
  contactInfo?: IContactInfoNew;
  bankAccount?: IBankAccount;
  legalRepresentative?: ILegalRepresentativeNew;
  agriculturalProduction?: boolean;
  agriculturalProductsProcessing?: boolean;
  nonAgriculturalProduction?: boolean;
  agriculturalBusinessActivities?: { uuid: string; label?: string }[];
  otherAgriculturalBusinessActivities?: { uuid: string; label?: string }[];
  dataConsentType?: ConsentType;
}

export type IFarmStatus =
  | "PENDING"
  | "PENDING_APPROVAL"
  | "ACTIVE"
  | "PASSIVE"
  | "DELETED";

export interface IHeadOfficeNew {
  uuid?: string;
  street?: string;
  houseNumber?: string;
  place?: ISimpleObjectWithCode;
  municipality?: string;
  postalCode?: string;
  approved?: boolean;
  evidences?: IEvidence[];
  approval?: IApproval;
}

export interface IFarmSearch {
  registrationNumber: string;
  status: string;
  renewalDate: string;
}
export interface IBankAccount {
  uuid?: string;
  accountNumber?: string;
  bank?: INameCode;
  approved?: boolean;
  evidences?: IEvidence[];
  approval?: IApproval;
  referenceNumber?: string;
}

export interface ILegalRepresentativeNew extends IMemberNew {
  street?: string;
  houseNumber?: string;
  place?: string;
  municipality?: string;
  postalCode?: string;
  approved?: boolean;
}

export interface IRenewalCondition {
  farmStatus?: boolean;
  upzCondition?: boolean;
  countrysideTourism?: boolean;
  allowedAprCodes?: boolean;
  atLeastOnePlantCultureOrAnimal?: boolean;
  plantCulture?: boolean;
  animal?: boolean;
  readyForRenewal?: boolean;
  hasEDelivery?: boolean;
  hasEmailOrPhoneNumber?: boolean;
  agriculturalProcessingProductionBusinessType?: boolean;
  nonAgriculturalProductionBusinessType?: boolean;
}

export interface IPassiveStatusReason {
  uuid?: string;
  code?: string;
  name?: string;
  canGoToActive?: boolean;
}

export const CommunicationChannels = ["DELIVERY", "EMAIL", "SMS"] as const;
export type IPrimaryCommunicationChannel =
  (typeof CommunicationChannels)[number];

export interface ICommunicationChannel {
  uuid?: string;
  farm?: string | null;
  eInboxDelivery?: boolean;
  eInboxInfo?: boolean;
  emailDelivery?: boolean;
  emailInfo?: boolean;
  smsDelivery?: boolean;
  smsInfo?: boolean;
  primaryCommunicationChannel?: IPrimaryCommunicationChannel;
  createdAt?: string;
}
